import { render, staticRenderFns } from "./plmDocument.vue?vue&type=template&id=3d606eac&scoped=true"
import script from "./plmDocument.vue?vue&type=script&lang=js"
export * from "./plmDocument.vue?vue&type=script&lang=js"
import style0 from "./plmDocument.vue?vue&type=style&index=0&id=3d606eac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d606eac",
  null
  
)

export default component.exports